﻿import Helpers from "./helpers";

declare var Mustache: any;

export default class ProductGridLoad {

	private container: HTMLElement;
	private maxProducts = window.innerWidth > 1225 ? 8 : 6;

	constructor(container: HTMLElement, lazyLoadData?: any) {

		this.container = container;

		this.templateLazyLoad(lazyLoadData);

		if (this.shouldHideProducts()) {
			this.hideProductsOverLimit();
			this.addLoadMoreButton();
		}

	}

	private templateLazyLoad(lazyLoadData?: any) {
		if (lazyLoadData) {
			const template = document.querySelector('#productsPPCGridTemplate').innerHTML;
			const templated = Mustache.render(template, lazyLoadData);
			this.container.insertAdjacentHTML('beforeend', templated);
		}
	}

	private shouldHideProducts() {
		return this.container.querySelectorAll('.js-product-grid-load-item').length > this.maxProducts;
	}


	private hideProductsOverLimit() {

		const items = this.container.querySelectorAll('.js-product-grid-load-item') as NodeListOf<HTMLLIElement>;

		for (let i = this.maxProducts; i < items.length; i++) {

			items[i].style.display = 'none';

		}

	}

	private addLoadMoreButton() {

		const items = this.container.querySelectorAll('.js-product-grid-load-item') as NodeListOf<HTMLLIElement>;

		this.container.insertAdjacentHTML('afterend', '<button type="button" class="c-button c-button--secondary c-product-page__load-more-products-button js-product-grid-load-button" data-test="product-grid-load-more">Load more products</button>');

		const loadMoreButton = this.container.parentElement.querySelector('.js-product-grid-load-button');

		loadMoreButton.addEventListener('click', () => {

			for (let i = this.maxProducts; i < items.length; i++) {
				items[i].style.display = 'block';
			}

			Helpers.removeElement(loadMoreButton);

		});

	}

}
